import React, { Component } from 'react';
import { Step, StepLabel, Stepper } from 'material-ui/Stepper';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { lightBlue400, lightBlueA700, redA200 } from 'material-ui/styles/colors';

import Header from '../../components/Header';
import PersonalDetails from '../PersonalDetails';
import Certificate from '../Certificate';
import Quiz from '../Quiz';
import Video from '../Video';
import './style.css';

const stepperStyle = {
  display: 'flex',
  flexDirection: 'row',
};

const stepLabelStyle = {
  flexGrow: 1,
};

const theme = getMuiTheme({
  palette: {
    primary1Color: lightBlue400,
    primary2Color: lightBlueA700,
    primary3Color: redA200,
  },
});

class App extends Component {

  state = {
    details: {
      name: 'Test User',
    },
    stepIndex: 0,
    finished: false,
  };

  handleNext = () => {
    const { stepIndex } = this.state;
    this.setState({
      stepIndex: stepIndex + 1,
      finished: stepIndex >= 2,
    });
  };

  handlePrev = () => {
    const { stepIndex } = this.state;
    if (stepIndex > 0) {
      this.setState({ stepIndex: stepIndex - 1 });
    }
  };

  handleFinishDetails = (details) => {
    this.setState({ details });
    this.handleNext();
  };

  renderCurrentStep() {
    switch (this.state.stepIndex) {
      case 0:
        return <PersonalDetails onFinishDetails={this.handleFinishDetails} />;

      case 1:
        return <Quiz preTest onFinishQuiz={this.handleNext} />;

      case 2:
        return <Video onFinishVideo={this.handleNext} />;

      case 3:
        return <Quiz onFinishQuiz={this.handleNext} />;

      case 4:
        return <Certificate details={this.state.details} />;

      default:
        return null;

    }
  }

  render() {
    return (
      <MuiThemeProvider muiTheme={theme}>
        <div className="App">
          <div className="App-content">
            <Stepper activeStep={this.state.stepIndex} style={stepperStyle}>
              <Step>
                <StepLabel style={stepLabelStyle}>Begin</StepLabel>
              </Step>
              <Step>
                <StepLabel style={stepLabelStyle}>Pre-Test: 15 Questions</StepLabel>
              </Step>
              <Step>
                <StepLabel style={stepLabelStyle}>Training Video: 20 Minutes</StepLabel>
              </Step>
              <Step>
                <StepLabel style={stepLabelStyle}>Post-Test: 15 Questions</StepLabel>
              </Step>
              <Step>
                <StepLabel style={stepLabelStyle}>Certificate of Completion</StepLabel>
              </Step>
            </Stepper>
            {this.renderCurrentStep()}
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.js